// extracted by mini-css-extract-plugin
export default {"manual":"manual_manual__HD54q","manual__add":"manual_manual__add__WxMAn"};